export default (
  state = {
    isFetching: true,
    receivedAt: null,
    data: []
  },
  action
) => {
  switch (action.type) {
    case 'REQUEST_CURRENT_USER':
      return {
        ...state,
        isFetching: true
      }
    case 'RECEIVE_CURRENT_USER':
      return {
        ...state,
        isFetching: false,
        receivedAt: Date.now(),
        data: action.data
      }
    default:
      return state
  }
}
